import React from 'react/addons';

import {gettext} from 'ofs/i18n';
import NewsletterSignUp from 'ofs/components/mailing/NewsletterSignUp';

const MESSAGES = {
  TITLE: gettext("£20 off your first onefinestay booking"),
  BODY_COPY: gettext("Sign up to our newsletter and get £20 toward your first booking.  We\u0027ll send you a weekly dose of travel inspiration, keeping you up-to-date with onefinestay\u0027s finest homes."),
  PLACEHOLDER: gettext("Sign-up for email updates"),
  SUBMIT: gettext("Go"),
};

const WelcomeVoucher = React.createClass({
  render() {
    return (
      <div className="ofs-WelcomeVoucher">
        <div className="ofs-WelcomeVoucher__Wrapper">
          <h1 className="ofs-WelcomeVoucher__Title">{MESSAGES.TITLE}</h1>
          <div className="ofs-WelcomeVoucher__Body">
            <span className="ofs-WelcomeVoucher__Copy">{MESSAGES.BODY_COPY}</span>
            <NewsletterSignUp lightBackground={true} submitCopy={MESSAGES.SUBMIT} source="popup" />
          </div>
        </div>
      </div>
    )
  },
});

export default WelcomeVoucher;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/views/WelcomeVoucher.jsx
 **/